// extracted by mini-css-extract-plugin
module.exports = {"details":"OrderTypeDetails_details__xjDIU"};